import { useEffect, useState } from "react";
import { DropDownListOptionType } from "types/common/CommonType";

/** SearchField 컴포넌트 일부 비즈니스 로직을 훅으로  */
const useSearchFieldChange = (searchFieldOption: DropDownListOptionType[]) => {
  const [searchValue, setSearchValue] = useState<string>("");

  /** 초기 selected Datasource 드롭다운 옵션 */
  const initSearchSuggestions = searchFieldOption?.map((item) => item.label);

  const [searchSuggestions, setSearchSuggestions] = useState<string[]>(
    initSearchSuggestions
  );

  /** searchFieldOption 변경 시 재세팅 */
  useEffect(() => {
    handleSearchSuggestionsReset();
  }, [searchFieldOption]);

  const handleSearchValue = (updateValue: string) => {
    setSearchValue(updateValue);
  };
  const handleSearchSuggestions = (updateSuggestions: string[]) => {
    setSearchSuggestions(updateSuggestions);
  };

  const handleSearchValueDatasourceChange = (value: string) => {
    const getSearchItems = (searchValue: string, searchList: string[]) => {
      return searchList.filter((item) =>
        item.toLowerCase().includes(searchValue.toLowerCase())
      );
    };

    const updatedSearchSuggestions = getSearchItems(
      value,
      initSearchSuggestions
    );

    handleSearchValue(value);

    setSearchSuggestions(
      value.trim() === "" ? initSearchSuggestions : updatedSearchSuggestions
    );
  };

  const handleSearchSuggestionsReset = () => {
    setSearchSuggestions(initSearchSuggestions);
  };

  return {
    searchValue,
    searchSuggestions,
    handleSearchValue,
    handleSearchSuggestions,
    handleSearchSuggestionsReset,
    handleSearchValueDatasourceChange,
  };
};

export default useSearchFieldChange;
